import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import sidenav from './modules/sidenav'
import toolbar from './modules/toolbar'
import userInfo from './modules/userinfo'
import history from './modules/history'
import view from './modules/view'
import common from './modules/common'
import meta from './modules/meta'
import purchases from './modules/purchases'
import importer from './modules/importer'
import charts from './modules/charts'
import selection from './modules/selection'
import * as types from './mutation-types'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    auth,
    sidenav,
    toolbar,
    userInfo,
    history,
    view,
    common,
    meta,
    purchases,
    importer,
    charts,
    selection
  },
  actions: {
    resetUserData ({ commit }) {
      const names = [
        `purchases/${types.PURCHASES_RESET}`,
        types.AUTH_RESET,
        types.USER_INFO_RESET,
        types.META_RESET,
        types.HISTORY_RESET
      ]

      names.forEach((name) => {
        commit(name)
      })
    }
  }
})

store.watch(
  (state) => state.auth.metadata,
  (val) => {
    if (store.state.auth.user && val && val.refreshTime) {
      store.dispatch('updateClaims', { forceRefresh: true })
    }
  }
)

export default store
